import PageHero from "../../components/sections/PageHero";
import ProjectRow from "../../components/ui/ProjectRow";
import { useProjects } from "../../hooks/useCMSData";

const filters = [
  "All Work",
  "Web & Digital",
  "Custom Software",
  "CRM & ERP",
  "AI & Automation",
  "LegalTech",
  "Healthcare",
  "Real Estate",
];

const WorkIndex = () => {
  const { data: projects } = useProjects();

  return (
    <>
      <PageHero
        label="WORK"
        title="The"
        titleAccent="work."
        subtitle="500+ projects across 15 industries."
      />

      <section style={{ background: "#050505", padding: "0 0 120px" }}>
        <div style={{ maxWidth: 1200, margin: "0 auto", padding: "0 clamp(20px, 4vw, 48px)" }}>
          <div style={{ display: "flex", flexWrap: "wrap", gap: 10, marginBottom: 32 }}>
            {filters.map((filter) => (
              <span key={filter} style={{ padding: "8px 12px", border: "1px solid rgba(212,168,67,0.18)", borderRadius: 3, fontFamily: "'DM Sans', sans-serif", fontSize: 12, color: "#908A83" }}>
                {filter}
              </span>
            ))}
          </div>

          <div style={{ borderTop: "0.5px solid rgba(212,168,67,0.18)" }}>
            {projects.map((project) => (
              <ProjectRow key={project.id} {...project} />
            ))}
          </div>
        </div>
      </section>
    </>
  );
};

export default WorkIndex;
